const fileManagement = {
    state: {
      docPath: '',
      fileName: '',
      uploadDisabled: false,
      breadcrumbArr: [{
        name: '全部文件',
        documentId: '*'
      }],
      viewFileDialog: false
    },
    mutations: {
      GET_DOCPATH: (state, status) => {
        state.docPath = status;
      },
      GET_FILENAME: (state, status) => {
          console.log(status, 'GET_FILENAME')
        state.fileName = status;
      },
      SET_DISABLED: (state, status) => {
        state.uploadDisabled = status;
      },
      SET_BREADCRUMBARR: (state, arr) => {
        state.breadcrumbArr = arr;
      },
      CHANGE_VIEW_FILE_DIALOG: (state, val) => {
        state.viewFileDialog = val;
      }
    },
    actions: {
      
    }
  }
  
  export default fileManagement


// WEBPACK FOOTER //
// ./src/store/modules/qa/fileManagement.js